import React from 'react'
import './continuedisable.css'

function ContinueDisabled() {
  return (
    <div className='btn-wrapper'>
        <span className='disable-btn'>Continue</span>
    </div>
  )
}

export default ContinueDisabled